import React from 'react';
import './TeamSection.css';
import vcnrWordmark from '../Assets/vcnrword.png'; // placeholder, replace with your asset
import teamImg from '../Assets/team.png'; // placeholder, replace with your asset
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const TeamSection = () => {
  const navigate=useNavigate();
  return(
  <section className="team-section ">
    <h2 className="team-heading">The Heart of</h2>
    <div className="team-vcnr-bg">
      <img src={vcnrWordmark} alt="VCNR" className="team-vcnr-wordmark" />
    </div>
    <div className="team-img-wrap">
      <motion.span 
        className="team-circle team-circle-left"
        animate={{
          y: [0, -30, 0, 30, 0],
          scale: [1, 1.08, 1, 0.95, 1],
          rotate: [0, 8, 0, -8, 0]
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
          ease: 'easeInOut',
          times: [0, 0.25, 0.5, 0.75, 1],
          delay: 0
        }}
      />
      <img src={teamImg} alt="VCNR Team" className="team-img" />
      <motion.span 
        className="team-circle team-circle-right"
        animate={{
          y: [0, 30, 0, -30, 0],
          scale: [1, 0.95, 1, 1.08, 1],
          rotate: [0, -8, 0, 8, 0]
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
          ease: 'easeInOut',
          times: [0, 0.25, 0.5, 0.75, 1],
          delay: 0.5
        }}
      />
    </div>
    <div className="team-desc">
At VCNR, people don’t just work, they belong.
Built with the founder’s humble beginnings, this is an organisation built on empathy. Our Founder, Mr.Murthy understands the pulse of people, their aspirations, struggles, and potential, because he’s walked that path himself. That is the reason VCNR isn’t run on policies alone, but on principles: Dignity, Care, and Trust.<br /><br />
VCNR is not a place where people are just hired and replaced. It’s a place where they truly belong. Here, you don’t just follow orders, you take ownership. Responsibility isn’t pushed around; it’s shared, embraced, and lived every day. Whether it’s an engineer shaping a new building, a doctor bringing care to a rural village, a designer crafting software, or a leader guiding strategy, everyone here is part of something bigger than a job description. People stay at VCNR not out of obligation, but out of choice. Because here, they are seen, heard, and valued, not just as professionals, but as people. This is a place that nurtures talent, fuels ambition, and respects the human being behind every role.
    </div>
    <div className="team-quote">
     "Top business groups don’t grow from profits.<br />
      <span>They grow from people who never wanted to leave."</span>
    </div>
    <div className="team-btn-row">
      <button className="explore-btn" onClick={() => navigate("/Leadership")}>Meet Our Team</button>
    </div>
  </section>
  )
};

export default TeamSection; 